import { ReportsDisplayer } from "pages/reports/components/ReportsDisplayer"
import { ReportTypeEnum } from "pages/reports/interfaces/reports.interfaces"
import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"

const ReportsIndexPage = () => {
  return (
    <ReportsDisplayer reportType={ReportTypeEnum.Vehicle} tableId={ClpTableEnum.VehicleReports} />
  )
}

export default ReportsIndexPage
